import {useInstanceValue} from '../use-data-member';
import {useState} from 'react';
import {assertDefined} from '@wix/devzai-utils-common';

export function useControlledProperty<T> (
    value: T | undefined,
    defaultValue: T | undefined,
    valueChangeCallback: undefined | ((value: T) => void),
    uncontrolledDefaultValue: T
) : [T, (value: T) => void];
export function useControlledProperty<T, CHANGE_ARGS> (
    value: T | undefined,
    defaultValue: T | undefined,
    valueChangeCallback: undefined | ((value: T, valueChangeArgs: CHANGE_ARGS) => void),
    uncontrolledDefaultValue: T
) : [T, (value: T, valueChangeArgs: CHANGE_ARGS) => void]
export function useControlledProperty<T, CHANGE_ARGS = any> (
    value: T | undefined,
    defaultValue: T | undefined,
    valueChangeCallback: undefined | ((value: T) => void) | ((value: T, valueChangeArgs: CHANGE_ARGS) => void),
    uncontrolledDefaultValue: T
) : [T, (value: T) => void] | [T, (value: T, valueChangeArgs: CHANGE_ARGS) => void] {

    const isControlled = useInstanceValue(() => {

        const isControlled = value !== undefined;

        if (isControlled && defaultValue !== undefined) {
            console.warn(`default value property is redundant for controlled component`);
        }

        return isControlled;
    })

    if (!isControlled && value !== undefined) {
        throw new Error(`A component is changing an uncontrolled component to be controlled.`);
    }

    if (isControlled && value === undefined) {
        throw new Error(`A component is changing a controlled component to be uncontrolled.`);
    }

    const [uncontrolledValue, setUncontrolledValue] = useState<T>(defaultValue ?? uncontrolledDefaultValue)

    return [
        isControlled ? assertDefined(value) : uncontrolledValue,
        (value: T, valueChangeArgs: CHANGE_ARGS) => {
            if (!isControlled) {
                setUncontrolledValue(value);
            }

            if (valueChangeCallback) {
                valueChangeCallback(value, valueChangeArgs);
            }
        }
    ];
}
